// Service-worker bootstrap for the Pacco customizer.
//
// Registers /sw.js on app startup so subsequent visits serve GLBs / textures
// from local cache — the dominant perf win on slow mobile connections where
// the Shopify CDN round-trip dominates the time-to-first-render.
//
// Safe to call on every app mount: the browser dedupes existing registrations.

export async function registerPaccoServiceWorker(): Promise<void> {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  // Skip on `file://` or non-secure contexts (SW requires HTTPS or localhost).
  if (!window.isSecureContext && window.location.hostname !== 'localhost') return;

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
    // Background update check: if the SW file changed on the server, the browser
    // picks it up on next navigation. No need to force reload here.
    registration.update().catch(() => {});
  } catch (err) {
    // Non-fatal — app still works, just without the offline cache.
    console.warn('[SW] registration failed:', err);
  }
}

/** Purge GLB + texture caches. Useful after a "sincronizar cache" click in
 *  admin so the next load sees fresh assets even if URLs were reused. */
export async function purgePaccoCaches(): Promise<void> {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker?.controller) return;
  navigator.serviceWorker.controller.postMessage({ type: 'purge' });
}
